function blankFilter() {
  return {
    schedules: [],
    date: new Date(),
    scheduleIds: [],
    professionalId: '',
    statuses: [],
    search: '',
  };
}

export default {
  items: [],
  loading: false,
  filter: blankFilter(),
  config: {
    show: false,
    processing: false,
    loaded: false,
    form: {
      placeId: '',
      roomName: '',
    },
  },
};
